import { createContext } from "react";
import type { ThemeMode } from "./types";

export interface ThemeState {
	mode: ThemeMode | null;
	changeMode: (mode: ThemeMode) => void;
}

export const ThemeContext = createContext<ThemeState>({
	mode: null,
	changeMode: () => {
		// do nothing
	},
});
